module.exports = __webpack_public_path__ + "img/2019110800.a0cd0a15.jpg";